module.exports = __webpack_public_path__ + "static/img/8.109e56f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/zh/8.png
// module id = FfOU
// module chunks = 0